import type { ClientOrganization } from "shared-core/types/organization";
import type { UserData } from "shared-core/types/user";

export const AuthStoreInjectKey = Symbol("auth-store");

export interface AuthStoreActions {
  logout(): Promise<void>;
  clearSession(): Promise<void>;
  checkAuth(
    force: boolean,
    options?: { propagateError?: boolean },
  ): Promise<void>;
  fetchOrganization(force: boolean): Promise<void>;
}

export interface AuthStoreState {
  user: UserData | null;
  registrationCredential: string | null;
  organization: null | ClientOrganization;
}

export interface AuthStoreGetters {
  isImpersonating: boolean;
  isTryggHansa: boolean;
  isGjensidige: boolean;
  isIf: boolean;
  isSvedea: boolean;
  isAdministrator: boolean;
  isControlaUser: boolean;
  totalBlockedAttacks: number;
  estimatedBreachCost: number;
}

export interface AuthStore extends AuthStoreState, AuthStoreGetters {}
